import { chain } from '@/lib/constants/config';
import { errorHandler } from '@/lib/utils/error-handler';
import { useQuery } from '@tanstack/react-query';
import { formatEther } from 'viem';
import { usePublicClient } from 'wagmi';

export const useBalance = (address: `0x${string}` | undefined) => {
  const publicClient = usePublicClient({ chainId: chain.id });
  const balance = useQuery<number, Error>({
    queryKey: ['/blockchain/balance', address],
    queryFn: async () => {
      try {
        if (!address) throw new Error('Address is required.');
        if (!publicClient) throw new Error('Public client is required.');
        const balance = await publicClient.getBalance({ address });
        return Number(formatEther(balance));
      } catch (e: any) {
        errorHandler(e);
      }
    },
    enabled: Boolean(address && publicClient),
    refetchInterval: chain.blockTime * 3,
    staleTime: chain.blockTime * 3,
  });
  return { balance };
};
